import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class SystemConfigService {
  static ENDPOINT = `${BASE}/systemConfig`;

  static async getScoreDateBase() {
    return await request({
      url: `${this.ENDPOINT}/score-date-base`,
      headers: { Accept: 'application/json' }
    });
  }

  static async updateScoreDateBase(day, month) {
    return await request({
      url: `${this.ENDPOINT}/score-date-base`,
      method: 'PUT',
      body: { Day: Number(day), Month: Number(month) }
    });
  }
}

export default SystemConfigService;
